export const CLIENT_COMP_VERSION = "1.0.2";
